module.exports = __webpack_public_path__ + "static/media/Marching-Band-Educational-Use-Video-Agreement.452f8bba.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/20-21/Marching-Band-Educational-Use-Video-Agreement.pdf
// module id = 199
// module chunks = 0